
export type SDKEventTypeName = 'SDKLandingPageReady'
  | 'UpdateUsername'
  | 'SDKReady'
  | 'UpdatePermissions'
  | 'SignUpUserAndCampaignCreated'
  | 'SignUpComplete'
  | 'CampaignCreated'
  | 'LoginCompleted'
  | 'SDKAdBannerReady'
  | 'AdBannerClicked'
  | 'SDKPMaxLPReady'
  | 'SDKSignInWithExistingAccount'
  | 'SDKRedirectToSignInWithExistingAccountPage';

export const SDKEventTypes: Record<SDKEventTypeName, SDKEventTypeName> = {
  SDKReady: 'SDKReady',
  UpdatePermissions: 'UpdatePermissions',
  SignUpUserAndCampaignCreated: 'SignUpUserAndCampaignCreated',
  SignUpComplete: 'SignUpComplete',
  CampaignCreated: 'CampaignCreated',
  LoginCompleted: 'LoginCompleted',
  SDKLandingPageReady: 'SDKLandingPageReady',
  UpdateUsername: 'UpdateUsername',
  SDKAdBannerReady: 'SDKAdBannerReady',
  AdBannerClicked: 'AdBannerClicked',
  SDKPMaxLPReady: 'SDKPMaxLPReady',
  SDKSignInWithExistingAccount: 'SDKSignInWithExistingAccount',
  SDKRedirectToSignInWithExistingAccountPage: 'SDKRedirectToSignInWithExistingAccountPage',
};

export interface ISignUpUserAndCampaignCreatedPayload {
  cid: number;
  aid: number;
  uid: number;
  campaignId: number;
  username: string;
}

export interface ISignUpCompleteEventPayload {
  cid: number;
  aid: number;
  uid: number;
  campaignId: number;
  assetGroupId: number;
  username: string;
}

export interface ICampaignEventPayload {
  campaignId: number;
  assetGroupdId: number;
}

export interface IUpdateUsernameEventPayload {
  username: string;
}

export interface ISDKLandingPageReady {
  height: number;
}

export interface ISDKEvent<T extends SDKEventTypeName, P = any> {
  type: T;
  payload?: P;
}

export interface ICustomSupportOptionItem {
  text?: string;
  href: string;
  onClick?: () => void;
}

export interface ICustomSupportOptions {
  headerText: string;
  flowId?: string;
  supportOptions: ICustomSupportOptionItem[];
}

export interface ISupportOptions {
  IfShowLiveChat?: boolean;
  RequestCallText?: string;
  customSupportOptions?: ICustomSupportOptions;
}

export interface IServerContext {
  Permissions?: Record<string, boolean>;
  DynamicPermissions?: Record<string, boolean>;
  CCUIPilots?: Record<string, boolean> & { dynamic: Record<string, boolean>};
  Urls?: Record<string, string>;
  SupportOptions?: ISupportOptions;
}

export type SDKReadyEvent = ISDKEvent<'SDKReady', undefined>;
export type UpdatePermissionsEvent = ISDKEvent<'UpdatePermissions', IServerContext>;
export type SignUpUserAndCampaignCreatedEvent = ISDKEvent<'SignUpUserAndCampaignCreated', ISignUpUserAndCampaignCreatedPayload>;
export type SignUpCompleteEvent = ISDKEvent<'SignUpComplete', ISignUpCompleteEventPayload>;
export type CampaignCreatedEvent = ISDKEvent<'CampaignCreated', ICampaignEventPayload>;
export type LoginCompletedEvent = ISDKEvent<'LoginCompleted', undefined>;
export type SDKLandingPageReadyEvent = ISDKEvent<'SDKLandingPageReady', ISDKLandingPageReady>;
export type UpdateUsernameEvent = ISDKEvent<'UpdateUsername', IUpdateUsernameEventPayload>;
export type AdBannerClickedEvent = ISDKEvent<'AdBannerClicked', undefined>;
export type SDKAdBannerReadyEvent = ISDKEvent<'SDKAdBannerReady', undefined>;
export type SDKPMaxLPReadyEvent = ISDKEvent<'SDKPMaxLPReady', undefined>;
export type SDKSignInWithExistingAccountEvent = ISDKEvent<'SDKSignInWithExistingAccount', undefined>;
export type SDKRedirectToSignInWithExistingAccountPageEvent = ISDKEvent<'SDKRedirectToSignInWithExistingAccountPage', undefined>;
export type SDKEvent = SDKReadyEvent |
  UpdatePermissionsEvent |
  SignUpCompleteEvent |
  SignUpUserAndCampaignCreatedEvent |
  CampaignCreatedEvent |
  LoginCompletedEvent |
  UpdateUsernameEvent |
  SDKLandingPageReadyEvent |
  SDKAdBannerReadyEvent |
  AdBannerClickedEvent |
  SDKPMaxLPReadyEvent |
  SDKSignInWithExistingAccountEvent |
  SDKRedirectToSignInWithExistingAccountPageEvent;

export function sendSDKEvent(evt: SDKEvent) {
  if (window.parent) {
    window.parent.postMessage(evt, '*');
  }
}
